import script from "./SalonView.vue?vue&type=script&setup=true&lang=js"
export * from "./SalonView.vue?vue&type=script&setup=true&lang=js"

import "./SalonView.vue?vue&type=style&index=0&id=7ff55d0e&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ff55d0e"]])

export default __exports__